import { useState } from "react";
import { Numerical, Page } from "../../types";
import styles from "./index.module.scss";
import PageCard from "../page-card";
import classes from "classnames";
import { useNavigate } from "react-router-dom";
import CoachPage from "../coach-page";

export interface PageEntryProps {
  type?: "page" | "coach";
  page: Omit<Page, "components">;
  fullWidth?: boolean;
  onUpdate?: () => void;
  onPageCardClick?: (page: Omit<Page, "components">) => void;
}

const PageEntryCatalog = ({
  type = "page",
  page,
  fullWidth,
  onUpdate = () => {},
  onPageCardClick,
}: PageEntryProps) => {
  const navigate = useNavigate();
  const [coachVisible, setCoachVisible] = useState(false);
  const [curCoachId, setCurCoachId] = useState<Numerical>(0);

  const handlePageCardClick = (p: Omit<Page, "components">) => {
    onPageCardClick?.(p);
    if (p.status === "lock") {
      return;
    }
    if (type === "coach") {
      navigate(`../coach/${p.id}`, {
        relative: "path",
      });
      return;
    }

    navigate(`../page/${p.id}`, {
      relative: "path",
    });
  };

  const showCoachPage = (coach: Omit<Page, "components">) => {
    onPageCardClick?.(coach);
    if (coach.status === "lock") {
      return;
    }
    setCurCoachId(coach.id);
    setCoachVisible(true);
  };

  const hideCoachPage = () => {
    setCurCoachId(0);
    setCoachVisible(false);
    onUpdate();
  };

  return (
    <div
      className={classes(styles.pageEntry, styles[page.status])}
      id={`page-${page.id}`}
    >
      <PageCard
        page={page}
        className={styles.pageCard}
        fullWidth={fullWidth}
        onClick={() => handlePageCardClick(page)}
      />

      {page.coaches?.map((coach) => (
        <PageCard
          fullWidth={fullWidth}
          className={styles.pageCard}
          page={coach}
          key={coach.id}
          onClick={() => showCoachPage(coach)}
        />
      ))}

      {/* 非独立页面 coach */}
      {!!curCoachId && (
        <CoachPage
          challengeId={curCoachId}
          visible={coachVisible}
          onClose={() => hideCoachPage()}
        />
      )}
    </div>
  );
};

export default PageEntryCatalog;
